exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".react-tree li a.react-tree-node-selected .cus-label{background-color:#fff;border:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./examples/showcases/basic.less
 ** module id = 233
 ** module chunks = 0
 **/